export class SnDrawerData<D = any> {
  public static createWithProxy<D = any>(data: D): SnDrawerData<D> {
    const drawerData = new SnDrawerData(data);

    return new Proxy(drawerData, {
      get: (target, property: string) => {
        if (property === '__drawerData__') {
          return target[property];
        }

        return target.__drawerData__[property];
      },
      set: (target, property, value) => {
        if (property === '__drawerData__') {
          target[property] = value;
        }
        {
          target.__drawerData__[property] = value;
        }
        return true;
      },
      has: (target, property) => {
        return property in target.__drawerData__;
      },
      ownKeys: (target) => {
        return Object.keys(target.__drawerData__);
      },
      getOwnPropertyDescriptor: (target, property) => {
        return Object.getOwnPropertyDescriptor(target.__drawerData__, property);
      },
    });
  }

  constructor(private __drawerData__: D) {}
}
